import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        '.MuiStep-horizontal': {
            paddingLeft: '0',
            paddingRight: '0'
        },
    })
);